import { stopLoading, startLoading} from 'app/store/utilSlice';
import { apiGet, apiPut, apiDel, apiPost } from 'app/shared-components/util/restAPI';
import { warningMessage } from 'app/shared-components/util/message';
import { toSafeHttpUrl } from 'app/shared-components/util/safeHttpUrl';


async function manageBilling(dispatch, returnPath){
	 try{
		  dispatch(startLoading());
	      const apiName = 'CoreAPI2';
		    const path = '/x2/stripe/portalsession';
	      const options = {
			  body: { returnPath },
			  headers: {},
			  response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
		  };
	
		 const data= await apiPost(apiName, path, options);

		 // data.url comes back from the server, but it is handed to window.open(), which runs a
		 // `javascript:` URL in this origin. Only an http(s) URL is opened.
		 const safeUrl= toSafeHttpUrl(data?.url);
		 if (!safeUrl){
			warningMessage(dispatch, "The billing page could not be opened.");
			return;
		 }

		 try{
			window.open(safeUrl, '_blank').focus();
		 }catch(error){
			warningMessage(dispatch, "The billing window was blocked by your browser. Please check pop-up blocker settings and allow this site.");
		 }
	 }finally{
		 dispatch(stopLoading());
	 }
  }
  
export default manageBilling;